export default function Editor(state = '', action){
  if (action.type === 'dataEditor') {
    return state = action.editor;
  } else {
    return state;
  }
}
